module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQSE4yWnlCM2FXUjBhRDBpTVRJNElpQm9aV2xuYUhROUlqRXlPQ0lnZUcxc2JuTTlJbWgwZEhBNkx5OTNkM2N1ZHpNdWIzSm5Mekl3TURBdmMzWm5JajQ4Y0dGMGFDQmtQU0pOTUNBMU5DNDROVGRvTXpZdU5UY3hWakV5T0Vnd1ZqVTBMamcxTjNwTk9URXVOREk1SURJM0xqUXpTREV5T0ZZeE1qaElPVEV1TkRJNVZqSTNMalF5T1hwTk5EVXVOekUwSURCb016WXVOVGN5ZGpFeU9FZzBOUzQzTVRSV01Ib2lMejQ4TDNOMlp6ND0i"


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/chart.svg
// module id = RjYk
// module chunks = 10